import { useSnackbar } from 'notistack';
import React from 'react';

import { GradeSheetsViewModel, useFileDownload } from '@/api';
import { UIDropzone } from '@/shared/components';

import { extractFileName } from './duck';

interface UploadGradeSheetsProps {
  onDrop: (files: File[]) => void;
  maxFiles?: number;
  maxSize?: number;
  multiple?: boolean;
  disabled?: boolean;
  gradeSheets?: GradeSheetsViewModel[];
  onMarkForDeletion: (fileId: string) => void;
}

const UploadGradeSheets: React.FC<UploadGradeSheetsProps> = ({
  onDrop,
  maxFiles,
  maxSize,
  multiple = false,
  disabled,
  gradeSheets = [],
  onMarkForDeletion,
}) => {
  const { enqueueSnackbar } = useSnackbar();
  const [currentFilePath, setCurrentFilePath] = React.useState<string>('');

  const {
    downloadFileFromMinio
  } = useFileDownload(currentFilePath);

  const displayedInitialFiles = React.useMemo(() => {
    if (gradeSheets && gradeSheets.length > 0) {
      return gradeSheets.map(gradeSheet => ({
        id: gradeSheet.id,
        name: extractFileName(gradeSheet.filePath, gradeSheet.grader),
        filePath: gradeSheet.filePath,
      }));
    }
    return [];
  }, [gradeSheets]);

  React.useEffect(() => {
    if (downloadFileFromMinio && currentFilePath) {
      /*try {
        const blob = new Blob([downloadFileFromMinio], { type: 'application/octet-stream' }); // TODO

        const url = window.URL.createObjectURL(blob);

        const a = document.createElement('a');
        a.href = url;
        a.download = currentFilePath.split('/').pop() || 'download';
        document.body.appendChild(a);
        a.click();

        window.URL.revokeObjectURL(url);
        document.body.removeChild(a);

        setCurrentFilePath('');
      } catch (error) {
        enqueueSnackbar({
          message: `Failed to process downloaded file${error instanceof Error ? ': ' + error.message : ''}`,
          variant: 'error',
        });
      }*/
    }
  }, [downloadFileFromMinio, currentFilePath, enqueueSnackbar]);

  const handleDeleteGradeSheet = (fileId: string) => {
    onMarkForDeletion(fileId);
  };

  const handleDownloadGradeSheet = (filePath: string) => {
    setCurrentFilePath(filePath);
  };

  return (
    <UIDropzone
      onDrop={onDrop}
      maxFiles={maxFiles}
      maxSize={maxSize}
      multiple={multiple}
      disabled={disabled}
      initialFiles={displayedInitialFiles}
      onDeleteInitialFile={handleDeleteGradeSheet}
      onDownloadInitialFile={handleDownloadGradeSheet}
    />
  );
};

export default UploadGradeSheets;